import { VALUES_PER_PAGE } from 'components/pagination/constants';
import { observable } from 'mobx';
import { DEFAULT_COLUMNS } from 'modules/userManager/constants';

class UserManagerStore {
  @observable content = [];

  @observable columns =
    JSON.parse(localStorage.getItem('columns')) || DEFAULT_COLUMNS;

  @observable aggregations = {};

  @observable sortOptions = {};

  @observable page = 0;

  @observable perPage = VALUES_PER_PAGE.TEN;

  @observable totalElements = 0;

  @observable selectAll = false;

  @observable selectedUsersListIds = [];

  @observable selectedConsumer = {};

  configs = {};
}

export default new UserManagerStore();
